import React from 'react'
import { Flex, Text, Box } from "@chakra-ui/react"
import { useSelector } from 'react-redux';

export const Cards = ({ text, icon, currentView, iconOnly = false }) => {

  const pageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor
  );
  return (
    <Flex
      justifyContent={iconOnly ? "center" : "space-around"}
      alignItems="center"
      width={iconOnly ? ["40px", "44px", "48px"] : ["110px", "130px", "150px"]}
      height={iconOnly ? ["36px", "38px", "40px"] : ["36px", "38px", "40px"]}
      borderRadius="8px"
      boxShadow="lg"
      border={currentView ? `${pageColor} 2px solid` : "1px solid #fff"}
      px={3}
    >
      <Box>{icon}</Box>
      {!iconOnly && (
        <Box>
          <Text fontSize={["12px", "14px", "16px"]}>{text}</Text>
        </Box>
      )}
    </Flex>
  );
}
